import _ from "underscore";
import React from "react";
import {Link} from "react-router";

import {FormControl, IconButton, TextField} from "@material-ui/core";
import LinkIcon from "@material-ui/icons/Link";

import {OrganisationId} from "common/types/organisation";
import {ProjectId, Project} from "common/types/project";
import {Autocomplete} from "@material-ui/lab";

interface Props {
  organisationId: OrganisationId;
  projectId: ProjectId | null;
  projects: Project[];
  selectProject: (projectId: ProjectId | null) => void;
  disableClearable?: boolean;
  autocompleteStyle?: object;
}

export default function ProjectSelector({
  organisationId,
  projectId,
  projects,
  selectProject,
  disableClearable,
  autocompleteStyle,
}: Props) {
  if (!Array.isArray(projects)) {
    return null;
  }
  const projectsById = projects.reduce((obj, doc) => {
    obj[doc.id] = doc;
    return obj;
  }, {});
  return (
    <div style={{display: "flex", alignItems: "center"}}>
      <FormControl variant="outlined">
        <Autocomplete
          disableClearable={disableClearable ?? false}
          style={autocompleteStyle ?? {}}
          value={projectId}
          id="project-select"
          onChange={(_, value) => selectProject(value ? value : null)}
          getOptionLabel={projectId =>
            projectsById[projectId as ProjectId]?.name ?? "unknown project"
          }
          options={_.sortBy(projects, project => project.name).map(
            project => project.id,
          )}
          renderOption={option => {
            const project = projectsById[option as ProjectId];
            return (
              <div
                key={project.id}
                style={{
                  whiteSpace: "normal",
                  wordWrap: "break-word",
                  overflowWrap: "break-word",
                  wordBreak: "break-all",
                  maxWidth: "100%",
                  textOverflow: "ellipsis",
                }}
              >
                {project.name}
              </div>
            );
          }}
          renderInput={params => (
            <TextField {...params} label="Project" variant="outlined" />
          )}
          ListboxProps={{
            style: {
              overflowX: "hidden",
            },
          }}
        ></Autocomplete>
      </FormControl>
      {projectId ? (
        <Link
          to={`/organisation/${organisationId}/project/${projectId}/document/list`}
        >
          <IconButton>
            <LinkIcon />
          </IconButton>
        </Link>
      ) : null}
    </div>
  );
}
